import { SET_MAP_ADDON } from './types';

export const setMapAddon = mapAddon => ({
  type: SET_MAP_ADDON,
  mapAddon,
});

export default setMapAddon;
